module.exports = __webpack_public_path__ + "img/about_product_1.0e241dc5.png";